import { HedgingsLoaded, HedgingConfigurationLoaded, HedgingSettingUpdated, BulkHedgingSettingUpdated, BulkHedgingSettingAllLocationsUpdated } from "./hedgings.actions";
import { HedgingSettings } from "./hedgingSettings";
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import HedgingConfiguration from "./hedgingConfiguration"
import HedgingFields from "./hedgingFields"

export class HedgingsReducer extends ReducerBase<HedgingSettings[]> {
    constructor() {
        super();
        this.addHandler(HedgingsLoaded.EventName, this.handleHedgingsLoaded);
        this.addHandler(HedgingSettingUpdated.EventName, this.handleHedgingSettingUpdated);
        this.addHandler(BulkHedgingSettingUpdated.EventName, this.handleBulkHedgingSettingUpdated);
        this.addHandler(BulkHedgingSettingAllLocationsUpdated.EventName, this.handleBulkHedgingSettingAllLocationsUpdated);
    }

    handleHedgingsLoaded(
        state: HedgingSettings[] = initialState.hedgingSettings
        , event: HedgingsLoaded): HedgingSettings[] {
        return event.hedgingSettings;
    }

    handleHedgingSettingUpdated(
        state: HedgingSettings[] = initialState.hedgingSettings,
        event: HedgingSettingUpdated
    ): HedgingSettings[] {
        return state.map(p => (
            (p.commodityId === event.hedgingSetting.commodityId
                && p.locationId === event.hedgingSetting.locationId
                && p.offerTypeId === event.hedgingSetting.offerTypeId)
                ? event.hedgingSetting
                : p
        ));
    }

    handleBulkHedgingSettingUpdated(
        state: HedgingSettings[] = initialState.hedgingSettings,
        event: BulkHedgingSettingUpdated
    ): HedgingSettings[] {
        var newState = state.map(value => Object.assign({}, value));
        return newState.map(hedging => {
            event.bulkHedgingSetting.offerings.map(elem => {
                if (hedging.locationId === event.bulkHedgingSetting.locationId &&
                    hedging.commodityId === elem.commodityId &&
                    hedging.offerTypeId === elem.offerTypeId
                ) {
                    switch (event.bulkHedgingSetting.key.toLocaleLowerCase()) {
                        case HedgingFields.UseFcmAccountFromPosition:
                            if (elem.value === "true") {
                                hedging.fcmAccountId = null;
                                hedging.useFcmAccountFromPosition = true;
                            }
                            else {
                                hedging.useFcmAccountFromPosition = false;
                            }
                            break;
                        case HedgingFields.FcmAccountId:
                            hedging.fcmAccountId = elem.value != null ? Number.parseInt(elem.value) : null;
                            hedging.useFcmAccountFromPosition = elem.value != null ? false : hedging.useFcmAccountFromPosition;
                            break;                            
                        case HedgingFields.UseMiniFcmAccountFromPosition:
                            if (elem.value === "true") {
                                hedging.miniContractFcmAccountId = null;
                                hedging.useMiniFcmAccountFromPosition = true;
                            }
                            else {
                                hedging.useMiniFcmAccountFromPosition = false;
                            }
                            break;
                        case HedgingFields.MiniContractFcmAccountId:
                            hedging.miniContractFcmAccountId = elem.value != null ? Number.parseInt(elem.value) : null;
                            break;
                        case HedgingFields.UseFullContractMinOfferFromPosition:
                            if (elem.value === "true") {
                                hedging.fullContractMinOffer = null;
                                hedging.useFullContractMinOfferFromPosition = true;
                            }
                            else {
                                hedging.useFullContractMinOfferFromPosition = false;
                            }
                            break;
                        case HedgingFields.FullContractMinOffer:
                            hedging.fullContractMinOffer = elem.value != null ? Number.parseInt(elem.value) : null;
                            hedging.useFullContractMinOfferFromPosition = elem.value != null ? false : hedging.useFullContractMinOfferFromPosition;
                            break;
                        case HedgingFields.UseMiniContractMinOfferFromPosition:
                            if (elem.value === "true") {
                                hedging.miniContractMinOffer = null;
                                hedging.useMiniContractMinOfferFromPosition = true;
                            }
                            else {
                                hedging.useMiniContractMinOfferFromPosition = false;
                            }
                            break;
                        case HedgingFields.MiniContractMinOffer:
                            hedging.miniContractMinOffer = elem.value != null ? Number.parseInt(elem.value) : null;
                            hedging.useMiniContractMinOfferFromPosition = elem.value != null ? false : hedging.useMiniContractMinOfferFromPosition;
                            break;
                        default:
                            break;
                    }
                }
                return elem;
            });
            return hedging;
        });
    }

    handleBulkHedgingSettingAllLocationsUpdated(
        state: HedgingSettings[] = initialState.hedgingSettings,
        event: BulkHedgingSettingAllLocationsUpdated
    ): HedgingSettings[] {

        const value = event.bulkHedgingSettingsForAllLocations.locationDetails[0].value;
        var newState = state.map(m => Object.assign({}, m));
        if (event.bulkHedgingSettingsForAllLocations.commodityId == null && event.bulkHedgingSettingsForAllLocations.offerTypeId == null) {
            return newState.map(hedging => {
                switch (event.bulkHedgingSettingsForAllLocations.key.toLocaleLowerCase()) {
                    case HedgingFields.UseFcmAccountFromPosition:
                        hedging.fcmAccountId = null;
                        hedging.useFcmAccountFromPosition = value === "true";
                        break;
                    case HedgingFields.FcmAccountId:
                        hedging.fcmAccountId = value != null ? Number.parseInt(value) : null;
                        hedging.useFcmAccountFromPosition = false;
                        break;
                    case HedgingFields.UseMiniFcmAccountFromPosition:
                        hedging.miniContractFcmAccountId = null;
                        hedging.useMiniFcmAccountFromPosition = value === "true";
                        break;
                    case HedgingFields.MiniContractFcmAccountId:
                        hedging.miniContractFcmAccountId = value != null ? Number.parseInt(value) : null;
                        hedging.useMiniFcmAccountFromPosition = false;
                        break;
                    case HedgingFields.UseFullContractMinOfferFromPosition:
                        hedging.fullContractMinOffer = null;
                        hedging.useFullContractMinOfferFromPosition = value === "true";
                        break;
                    case HedgingFields.FullContractMinOffer:
                        hedging.fullContractMinOffer = value != null ? Number.parseInt(value) : null;
                        hedging.useFullContractMinOfferFromPosition = false;
                        break;
                    case HedgingFields.UseMiniContractMinOfferFromPosition:
                        hedging.miniContractMinOffer = null;
                        hedging.useMiniContractMinOfferFromPosition = value === "true";
                        break;
                    case HedgingFields.MiniContractMinOffer:
                        hedging.miniContractMinOffer = value != null ? Number.parseInt(value) : null;
                        hedging.useMiniContractMinOfferFromPosition = false;
                        break;
                    default:
                        break;
                }
                return hedging;
            });
        }
        else {
            return newState.map(hedging => {
                event.bulkHedgingSettingsForAllLocations.locationDetails.map(locationDetail => {
                    if (hedging.commodityId === event.bulkHedgingSettingsForAllLocations.commodityId &&
                        hedging.offerTypeId === event.bulkHedgingSettingsForAllLocations.offerTypeId
                    ) {
                        switch (event.bulkHedgingSettingsForAllLocations.key.toLocaleLowerCase()) {
                            case HedgingFields.FcmAccountId:
                                hedging.fcmAccountId = locationDetail.value != null ? Number.parseInt(locationDetail.value) : null;
                                break;
                            case HedgingFields.MiniContractFcmAccountId:
                                hedging.miniContractFcmAccountId = locationDetail.value != null ? Number.parseInt(locationDetail.value) : null;
                                break;
                            case HedgingFields.FullContractMinOffer:
                                hedging.fullContractMinOffer = locationDetail.value != null ? Number.parseInt(locationDetail.value) : null;
                                break;
                            case HedgingFields.MiniContractMinOffer:
                                hedging.miniContractMinOffer = locationDetail.value != null ? Number.parseInt(locationDetail.value) : null;
                                break;
                            default:
                                break;
                        }
                    }
                    return locationDetail;
                });
                return hedging;
            });
        }
    }

    handleDefault(state: HedgingSettings[] = initialState.hedgingSettings) {
        return state;
    }
}

export class HedgingConfigurationReducer extends ReducerBase<HedgingConfiguration> {
    constructor() {
        super();
        this.addHandler(HedgingConfigurationLoaded.EventName, this.handleConfigurationLoaded);
    }

    handleConfigurationLoaded(state: HedgingConfiguration = initialState.hedgingConfiguration, event: HedgingConfigurationLoaded
    ): HedgingConfiguration {
        return event.configuration;
    }

    handleDefault(state: HedgingConfiguration = initialState.hedgingConfiguration) {
        return state;
    }
}
